import axios from "axios";
import { BASE_URL } from "../../variables";

export const getCwpDetailsApi = async (Cluster, Region, Zone, SalesGroup) => {
  const options = {
    url: `${BASE_URL}/services/apexrest/CWP/`,
    method: "post",
    data: {
      cluster: Cluster,
      region: Region,
      zone: Zone,
      salesGroup: SalesGroup,
    },
  };
  try {
    const response = await axios(options);
    if (response.status === 200) {
      return {
        success: true,
        data: response?.data,
      };
    } else {
      throw Error("Something Went Wrong..!!");
    }
  } catch (err) {
    return {
      success: false,
      msg: "Somthing Went Wrong..!!",
    };
  }
};
